module.exports = __webpack_public_path__ + "img/2.a64f6d98.png";